module.exports = __webpack_public_path__ + "static/img/6197_phase_function_Paper_PointsHejduk_Prediction.69a7910.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6197_phase_function_Paper_PointsHejduk_Prediction.png
// module id = Y7HZ
// module chunks = 0